import { render, staticRenderFns } from "./JfUser.vue?vue&type=template&id=50a1bd7d&scoped=true"
import script from "./JfUser.vue?vue&type=script&lang=js"
export * from "./JfUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a1bd7d",
  null
  
)

export default component.exports